export const ADD_YOUR_PHONE_NUMBER_PLACEHOLDER = 'Add your Phone Number';
export const SHARE_YOUR_ISSUE_OR_THOUGHTS_HERE_PLACEHOLDER =
  'Share your issue or thoughts here';
export const SUBMIT_BTN = 'Submit';
